import { render } from "./admin-projects.vue?vue&type=template&id=29bac452&ts=true&lang=pug"
import script from "./admin-projects.vue?vue&type=script&lang=ts"
export * from "./admin-projects.vue?vue&type=script&lang=ts"

import "./admin-projects.vue?vue&type=style&index=0&id=29bac452&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__